import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { T } from '@sm/intl';
import { Toast } from '@wds/toast';
export const COPY = {
  pendingTitle: {
    id: 'OpenEndedCoding.ExportToastPending.PendingTitle',
    defaultMessage: 'Preparing your export.',
    description: '[Type: Label][Vis.: high] - Appears in the bottom of the browser as the title of export pending prompt'
  },
  pendingBody: {
    id: 'OpenEndedCoding.ExportToastPending.PendingBody',
    defaultMessage: 'Your download will begin automatically.',
    description: '[Type: Label][Vis.: high] - Appears in the bottom of the browser as the body of export pending prompt'
  }
};
const ToastPending = () => {
  return _jsxs(Toast, {
    autoClose: false,
    children: [_jsx(Toast.Title, {
      children: _jsx(T, {
        desc: COPY.pendingTitle
      })
    }), _jsx(Toast.Body, {
      children: _jsx(T, {
        desc: COPY.pendingBody
      })
    })]
  });
};
export default ToastPending;